import { MapDirectiveController } from './map.directive.controller'
import { SYSTEM_SERVICE_NAME, $SCOPE_SERVICE_NAME, $ELEMENT_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, SystemService } from '../../../services/system'

//#region Asset Imports

import './map.scss'
import * as TEMPLATE from './map.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'map2'

export class MapDirective implements ng.IDirective {

    scope = {
        options: '='
    }

    restrict = 'E'

    controller = [
        $SCOPE_SERVICE_NAME,
        $ELEMENT_SERVICE_NAME,
        $Q_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        SYSTEM_SERVICE_NAME, (
            $scope,
            $element: JQuery,
            $q: ng.IQService,
            $timeout: ng.ITimeoutService,
            systemService: SystemService
        ) => {
            return new MapDirectiveController($scope, $element, $q, $timeout, systemService)
        }]

    template = TEMPLATE

}